/* ==========================================================================
   TARRMU // BUG REPORT POPUP  (4_1_271)
   Bug button beside the desktop light/dark toggle -> modal with
   Title · Description · Screenshots (upload, up to 3) · Reporting as @username · Submit.
   Screenshots go to the private bug-report-shots bucket (own folder, RLS),
   then the report-bug edge fn stores the report and emails the moderators.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__tbugInit) return;
  window.__tbugInit = true;

  var MAX_SHOTS = 3, MAX_MB = 8;
  var OKEXT = ['png', 'jpg', 'jpeg', 'webp', 'gif'];
  var REASONS = {
    not_authenticated: 'Session expired \u2014 sign in again',
    title_too_short: 'Title needs at least 4 characters',
    description_too_short: 'Describe the bug in at least 10 characters',
    invalid_screenshot: 'One of the screenshots could not be attached',
    daily_limit: 'Limit reached \u2014 5 reports per day',
    no_profile_email: 'Your profile has no email on file',
    email_failed: 'Saved, but the email failed \u2014 we will still see it'
  };
  var BUG_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<path d="M8 2l1.9 1.9"/><path d="M16 2l-1.9 1.9"/><path d="M9 7.1V6a3 3 0 0 1 6 0v1.1"/>' +
    '<path d="M12 20c-3.3 0-6-2.7-6-6v-3a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v3c0 3.3-2.7 6-6 6z"/>' +
    '<path d="M12 20v-9"/><path d="M6.5 13H3"/><path d="M21 13h-3.5"/><path d="M6 9.5L3.5 8"/><path d="M18 9.5L20.5 8"/>' +
    '<path d="M6.3 17.5L4 19"/><path d="M17.7 17.5L20 19"/></svg>';

  function esc(s) {
    return (s == null ? '' : String(s)).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function T() { return window.Tarrmu && window.Tarrmu.SB_URL ? window.Tarrmu : null; }
  function memberToken() {
    try { var c = window.TarrmuAuth._readCache(); return (c && c.token) ? c.token : null; } catch (e) { return null; }
  }
  function uuid() { return window.TarrmuAuth && window.TarrmuAuth.ghostUuid; }

  /* ---------- button (beside every #tarrmuTheme) ----------
     tarrmu-v4 layoutHeader() pins the toggle at the far right (absolute,
     right:28px) on wide screens and re-parents it, so the bug button
     follows it: same parent, pinned just to its left, re-synced on resize
     and whenever the toggle's style/parent changes. */
  var GAP = 8;
  function follow(b, t) {
    if (b.parentNode !== t.parentNode || b.nextElementSibling !== t) t.parentNode.insertBefore(b, t);
    var cs = getComputedStyle(t);
    /* 4_1_300: use the toggle's MEASURED position (offsetTop + a rect check),
       not its computed top. The toggle can move without a style mutation
       (late fonts, profile chip mounting, back/forward cache restore), which
       left this button a few px off until a refresh. */
    if (cs.position === 'absolute') {
      var right = parseFloat(cs.right) || 0;
      b.style.setProperty('position', 'absolute', 'important');
      b.style.setProperty('right', (right + t.offsetWidth + GAP) + 'px', 'important');
      b.style.setProperty('top', t.offsetTop + 'px', 'important');
      b.style.setProperty('z-index', cs.zIndex || '6', 'important');
      b.style.setProperty('margin', '0', 'important');
      if (t.offsetHeight) b.style.setProperty('height', t.offsetHeight + 'px', 'important');
      var tr = t.getBoundingClientRect(), br = b.getBoundingClientRect();
      var dy = Math.round(tr.top - br.top);
      if (dy && Math.abs(dy) < 80) b.style.setProperty('top', (t.offsetTop + dy) + 'px', 'important');
    } else {
      ['position', 'right', 'top', 'z-index', 'margin', 'height'].forEach(function (p) { b.style.removeProperty(p); });
      b.style.setProperty('margin-right', GAP + 'px', 'important');
      if (t.offsetHeight) b.style.setProperty('height', t.offsetHeight + 'px', 'important');
      b.style.setProperty('align-self', 'center', 'important');
    }
  }
  /* 4_1_352: the header MutationObserver fires many times per render; each syncAll() writes styles then
     reads layout (forced reflow). Coalesce those re-syncs to one per frame. The first placement in
     mountButtons() still runs immediately, so the button doesn't appear later. */
  var syncQueued = false;
  function syncSoon() {
    if (syncQueued) return;
    syncQueued = true;
    (window.requestAnimationFrame || setTimeout)(function () { syncQueued = false; syncAll(); });
  }
  function syncAll() {
    var bs = document.querySelectorAll('.t-bug');
    for (var i = 0; i < bs.length; i++) if (bs[i]._tog && document.contains(bs[i]._tog)) follow(bs[i], bs[i]._tog);
  }
  function mountButtons() {
    var toggles = document.querySelectorAll('#tarrmuTheme');
    for (var i = 0; i < toggles.length; i++) {
      var t = toggles[i];
      if (t._bug) continue;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 't-toggle t-bug';
      b.setAttribute('aria-label', 'Report a bug');
      b.setAttribute('title', 'Report a bug');
      b.innerHTML = BUG_SVG;
      b.addEventListener('click', open);
      b._tog = t; t._bug = b;
      follow(b, t);
      try {
        new MutationObserver(syncSoon).observe(t, { attributes: true, attributeFilter: ['style', 'class'] });
      } catch (e) {}
    }
    try {
      var hdr = document.getElementById('gh-navigation') || document.body;
      new MutationObserver(syncSoon).observe(hdr, { childList: true, subtree: true });
    } catch (e) {}
    window.addEventListener('resize', syncSoon);
    window.addEventListener('load', syncAll);
    window.addEventListener('pageshow', function () { syncAll(); setTimeout(syncAll, 300); });
    document.addEventListener('visibilitychange', function () { if (!document.hidden) syncAll(); });
    try { if (document.fonts && document.fonts.ready) document.fonts.ready.then(syncAll); } catch (e) {}
    try {
      var ro = new ResizeObserver(function () { syncAll(); });
      var head = document.getElementById('gh-navigation') || document.querySelector('#gh-head, .gh-head, header');
      if (head) ro.observe(head);
      for (var k = 0; k < toggles.length; k++) ro.observe(toggles[k]);
    } catch (e) {}
    [300, 600, 1200, 2000, 4000, 8000].forEach(function (ms) { setTimeout(syncAll, ms); });
  }

  /* ---------- modal ---------- */
  var M = null, files = [], busy = false, lastFocus = null;

  function build() {
    M = document.createElement('div');
    M.id = 'tbug';
    M.setAttribute('hidden', '');
    M.innerHTML =
      '<div class="tbug-back" data-close></div>' +
      '<div class="tbug-dlg" role="dialog" aria-modal="true" aria-labelledby="tbug-h">' +
      '<div class="tbug-head"><div><div class="tbug-kick"><b>//</b> BUG REPORT</div>' +
      '<h2 id="tbug-h">Report a bug</h2></div>' +
      '<button type="button" class="tbug-x" data-close aria-label="Close">\u00d7</button></div>' +
      '<div class="tbug-body" id="tbug-body"></div>' +
      '</div>';
    document.body.appendChild(M);
    M.addEventListener('click', function (e) { if (e.target.closest('[data-close]') && !busy) close(); });
    document.addEventListener('keydown', function (e) {
      if (M.hidden) return;
      if (e.key === 'Escape' && !busy) close();
      if (e.key === 'Tab') trap(e);
    });
  }
  function trap(e) {
    var f = M.querySelectorAll('button:not([disabled]),input:not([disabled]),textarea:not([disabled]),a[href]');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function open() {
    if (!M) build();
    lastFocus = document.activeElement;
    files = [];
    M.hidden = false;
    document.documentElement.classList.add('tbug-lock');
    var body = document.getElementById('tbug-body');
    if (!uuid() || !memberToken()) {
      body.innerHTML = '<p class="tbug-p">Sign in to report a bug. Reports are linked to your profile so we can send your ' +
        '<span class="tbug-xp">+1000 XP</span> when it\u2019s confirmed and fixed.</p>' +
        '<div class="tbug-row"><a class="tbug-btn" href="#/portal/signin" data-portal="signin">[ Sign in ]</a></div>';
      var a = body.querySelector('a'); if (a) a.addEventListener('click', close);
      setTimeout(function () { var x = M.querySelector('.tbug-x'); if (x) x.focus(); }, 0);
      return;
    }
    renderForm(body);
  }
  function close() {
    if (!M) return;
    M.hidden = true;
    document.documentElement.classList.remove('tbug-lock');
    files.forEach(function (f) { if (f.url) URL.revokeObjectURL(f.url); });
    files = [];
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function renderForm(body) {
    body.innerHTML =
      '<form id="tbug-form" novalidate>' +
      '<div class="tbug-f"><label for="tbug-title">Title</label>' +
      '<input id="tbug-title" maxlength="140" autocomplete="off" placeholder="e.g. Trending tab goes blank"></div>' +
      '<div class="tbug-f"><label for="tbug-desc">Description</label>' +
      '<textarea id="tbug-desc" maxlength="4000" placeholder="What happened? What did you expect instead? Steps help a lot."></textarea></div>' +
      '<div class="tbug-f"><label>Screenshots <i>(optional \u00b7 up to ' + MAX_SHOTS + ' \u00b7 PNG / JPG / WEBP / GIF \u00b7 ' + MAX_MB + ' MB)</i></label>' +
      '<div class="tbug-drop" id="tbug-drop" tabindex="0" role="button" aria-label="Add screenshots">' +
      '<input type="file" id="tbug-file" accept="image/png,image/jpeg,image/webp,image/gif" multiple hidden>' +
      '<span>[ + ADD SCREENSHOTS ]</span><small>click, drop, or paste an image</small></div>' +
      '<div class="tbug-thumbs" id="tbug-thumbs"></div></div>' +
      '<div class="tbug-f"><label>Reporting as</label>' +
      '<div class="tbug-who" id="tbug-who"><span class="tbug-ava" id="tbug-ava"></span>' +
      '<span><b id="tbug-name">\u2026</b><small id="tbug-handle"></small></span></div></div>' +
      '<div class="tbug-page">Page: <span id="tbug-url"></span></div>' +
      '<div class="tbug-row"><button class="tbug-btn" id="tbug-send" type="submit">[ Submit report ]</button>' +
      '<span class="tbug-msg" id="tbug-msg" role="status"></span></div>' +
      '</form>';
    document.getElementById('tbug-url').textContent = location.href.split('#')[0];
    fillWho();
    var drop = document.getElementById('tbug-drop'), inp = document.getElementById('tbug-file');
    drop.addEventListener('click', function () { inp.click(); });
    drop.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); inp.click(); } });
    inp.addEventListener('change', function () { addFiles(inp.files); inp.value = ''; });
    drop.addEventListener('dragover', function (e) { e.preventDefault(); drop.classList.add('on'); });
    drop.addEventListener('dragleave', function () { drop.classList.remove('on'); });
    drop.addEventListener('drop', function (e) { e.preventDefault(); drop.classList.remove('on'); addFiles(e.dataTransfer.files); });
    document.getElementById('tbug-form').addEventListener('paste', function (e) {
      var items = (e.clipboardData && e.clipboardData.files) || [];
      if (items.length) { e.preventDefault(); addFiles(items); }
    });
    document.getElementById('tbug-form').addEventListener('submit', function (e) { e.preventDefault(); send(); });
    setTimeout(function () { document.getElementById('tbug-title').focus(); }, 0);
  }

  function fillWho() {
    var nm = document.getElementById('tbug-name'), hd = document.getElementById('tbug-handle'), av = document.getElementById('tbug-ava');
    var chip = null;
    try { chip = JSON.parse(localStorage.getItem('tarrmu_chip') || 'null'); } catch (e) {}
    function paint(name, handle, avatar) {
      nm.textContent = name || 'Member';
      hd.textContent = handle ? '@' + handle : '';
      av.textContent = '';
      av.style.backgroundImage = '';
      if (avatar && /^https?:\/\//.test(avatar)) av.style.backgroundImage = 'url("' + avatar.replace(/"/g, '') + '")';
      else av.textContent = (name || '?').trim().charAt(0).toUpperCase();
    }
    paint(chip && chip.name, null, chip && chip.avatar);
    var t = T();
    var rest = t && typeof t.rest === "function" ? t.rest : null;
    if (!rest) return;
    /* same call the header chip makes: member JWT authorises reading your own row */
    rest('profiles?select=username,display_name,avatar_url&ghost_uuid=eq.' + encodeURIComponent(uuid()) + '&limit=1')
      .then(function (rows) {
        var p = rows && rows[0];
        if (p) paint(p.display_name || p.username, p.username, p.avatar_url || (chip && chip.avatar));
      }).catch(function () {});
  }

  function msg(t, kind) {
    var m = document.getElementById('tbug-msg');
    if (!m) return;
    m.className = 'tbug-msg' + (kind ? ' ' + kind : '');
    m.textContent = t;
  }

  function addFiles(list) {
    for (var i = 0; i < list.length; i++) {
      var f = list[i];
      if (files.length >= MAX_SHOTS) { msg('Up to ' + MAX_SHOTS + ' screenshots', 'err'); break; }
      var ext = (f.type.split('/')[1] || '').replace('jpeg', 'jpg');
      if (OKEXT.indexOf(ext) === -1) { msg('PNG / JPG / WEBP / GIF only', 'err'); continue; }
      if (f.size > MAX_MB * 1024 * 1024) { msg('Each screenshot must be under ' + MAX_MB + ' MB', 'err'); continue; }
      files.push({ file: f, ext: ext, url: URL.createObjectURL(f) });
    }
    drawThumbs();
  }
  function drawThumbs() {
    var box = document.getElementById('tbug-thumbs');
    if (!box) return;
    box.innerHTML = files.map(function (f, i) {
      return '<div class="tbug-th"><img src="' + esc(f.url) + '" alt="screenshot ' + (i + 1) + '">' +
        '<button type="button" data-rm="' + i + '" aria-label="Remove screenshot ' + (i + 1) + '">\u00d7</button></div>';
    }).join('');
    box.querySelectorAll('[data-rm]').forEach(function (b) {
      b.addEventListener('click', function () {
        var k = +b.getAttribute('data-rm');
        URL.revokeObjectURL(files[k].url);
        files.splice(k, 1);
        drawThumbs();
      });
    });
    var d = document.getElementById('tbug-drop');
    if (d) d.style.display = files.length >= MAX_SHOTS ? 'none' : '';
  }

  function setBusy(on) {
    busy = on;
    M.querySelectorAll('#tbug-form input,#tbug-form textarea,#tbug-form button').forEach(function (el) { el.disabled = on; });
  }

  function send() {
    var title = document.getElementById('tbug-title').value.trim();
    var desc = document.getElementById('tbug-desc').value.trim();
    if (title.length < 4) return msg(REASONS.title_too_short, 'err');
    if (desc.length < 10) return msg(REASONS.description_too_short, 'err');
    var t = T(), tok = memberToken(), id = uuid();
    if (!t || !tok || !id) return msg(REASONS.not_authenticated, 'err');
    setBusy(true);
    var stamp = Date.now(), paths = [];
    var up = files.reduce(function (p, f, i) {
      return p.then(function () {
        msg('Uploading screenshot ' + (i + 1) + ' of ' + files.length + '\u2026');
        var path = id + '/' + stamp + '-' + i + '.' + f.ext;
        return fetch(t.SB_URL + '/storage/v1/object/bug-report-shots/' + path, {
          method: 'POST',
          headers: { apikey: t.SB_ANON, Authorization: 'Bearer ' + tok, 'Content-Type': f.file.type || 'application/octet-stream' },
          body: f.file
        }).then(function (r) {
          if (!r.ok) throw new Error('upload ' + r.status);
          paths.push(path);
        });
      });
    }, Promise.resolve());
    up.then(function () {
      msg('Sending\u2026');
      return fetch(t.SB_URL + '/functions/v1/report-bug', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', apikey: t.SB_ANON, Authorization: 'Bearer ' + tok },
        body: JSON.stringify({
          mode: 'submit', title: title, description: desc, screenshots: paths,
          page_url: location.href.split('#')[0].slice(0, 600),
          device: ((navigator.userAgent || '').slice(0, 300) + ' \u00b7 ' + window.innerWidth + '\u00d7' + window.innerHeight +
            ' \u00b7 ' + (document.documentElement.getAttribute('data-theme') || 'dark'))
        })
      }).then(function (r) { return r.json().catch(function () { return null; }); });
    }).then(function (res) {
      setBusy(false);
      if (res && res.ok) {
        document.getElementById('tbug-body').innerHTML =
          '<div class="tbug-done">// REPORT SENT \u2014 THANKS!</div>' +
          '<p class="tbug-p">A moderator will look at it. If it\u2019s confirmed and fixed you\u2019ll get an email and ' +
          '<span class="tbug-xp">+1000 XP</span>.</p>' +
          '<div class="tbug-row"><button type="button" class="tbug-btn" data-close>[ Close ]</button>' +
          '<a class="tbug-link" href="/report-bug/">[ Your reports ]</a></div>';
        files = [];
      } else {
        msg(REASONS[res && res.reason] || 'Could not send \u2014 try again', 'err');
      }
    }).catch(function () {
      setBusy(false);
      msg('Upload failed \u2014 try again', 'err');
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mountButtons);
  else mountButtons();
  window.TarrmuBug = { open: open };
})();
